import {BaseEntity} from "./BaseEntity";

export class EmployeeLocationHistory implements BaseEntity {
    constructor(
        public id?:number,
        public locationName?:string,
        public employeeFirstName?: string,
        public employeeLastName?: string,
        public employeeEmail?: string,
        public timeSeen?: string,
        public timeLeft?: string,
        public employeeID?:string){
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.locationName = json.locationName;
        this.employeeFirstName = json.employeeFirstName;
        this.employeeLastName = json.employeeLastName;
        this.employeeEmail = json.employeeEmail;
        this.timeSeen = json.timeSeen;
        this.timeLeft = json.timeLeft;
        this.employeeID = json.employeeID;
    }
}
